type GlobalAppContextKeyType = 'ChecklistReadonly' | 'OverviewSectionContextStore';

export const GlobalAppContextKey: Record<GlobalAppContextKeyType, symbol> = {
  ChecklistReadonly: Symbol('checklistReadonly'),
  OverviewSectionContextStore: Symbol('overviewSectionContextStore')
};
